module.exports = require("lodash/concat");